export default __webpack_public_path__ + "static/media/calendar-icon.7aebd91e.svg";